import { Injectable, Injector } from "@angular/core";
import { environment } from "@environments/environment";
import { ChangeEdiOrderAssignment } from "@interfaces/dto/changeEdiOrderAssignment.interface";
import { ChangeEdiOrderPriority } from "@interfaces/dto/changeEdiOrderPriority.interface";
import { Service } from "@services/service";

@Injectable()
export class EdiOrderService extends Service {
	constructor(injector: Injector) {
		super("EdiOrder", injector);
	}

	// API
	app_SetAsPicked(id: number) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/App_SetAsPicked/${id}`, {});
	}

	assignMachine(data: ChangeEdiOrderAssignment) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/AssignMachine`, data);
	}

	assignOperator(data: ChangeEdiOrderAssignment) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/AssignOperator`, data);
	}
	
	changePriority(data: ChangeEdiOrderPriority){
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/ChangePriority`, data);
	}

	futureSummary() {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/FutureSummary`);
	}

	getOrderTableByClient(id: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/OrderTableByClient/${id}`);
	}

	getOrderTableByClientLocation(id: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/OrderTableByClientLocation/${id}`);
	}

	getOrderTableClientAndLocationSelectionMenu() {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/OrderTableClientAndLocationSelectionMenu`);
	}

	getScheduleForPart(partId: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/ScheduleForPart/${partId}`);
	}

	pickList() {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/PickList`, { responseType: "blob" as "json" });
	}
}